import React from "react";

export default function ECGStats({ ecg, hr = true }) {
  return (
    <div className="stats">
      <table>
        <tbody>
          {hr ? (
            <tr>
              <td className="label">V.HR (bpm)</td>
              <td className="value">{ecg.ecgDetails.vhr}</td>
            </tr>
          ) : null}
          <tr>
            <td className="label">PR (ms)</td>
            <td className="value">{ecg.ecgDetails.pr}</td>
          </tr>
          <tr>
            <td className="label">QRS (ms)</td>
            <td className="value">{ecg.ecgDetails.qrs}</td>
          </tr>
          <tr>
            <td className="label">PRT (&deg;)</td>
            <td className="value">{ecg.ecgDetails.prt}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          {hr ? (
            <tr>
              <td className="label">A.HR (bpm)</td>
              <td className="value">{ecg.ecgDetails.ahr}</td>
            </tr>
          ) : null}
          <tr>
            <td className="label">QT (ms)</td>
            <td className="value">{ecg.ecgDetails.qt}</td>
          </tr>
          <tr>
            <td className="label">QTc (ms)</td>
            <td className="value">{ecg.ecgDetails.qtcorrected}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
